import type { ExtensionsCommandFactory } from '../ExtensionsModel';
import { getExtensions } from './api/getExtensionsApi';
import { stopExtension as stopExtensionApi } from './api/stopExtensionApi';

type StopExtensionCommand = {
  extensionId: string;
};

export const stopExtension: ExtensionsCommandFactory<StopExtensionCommand> =
  (cmdContext) => async (command) => {
    try {
      cmdContext.updateState((draft) => {
        draft.extensionsLoading = true;
      });
      await stopExtensionApi(command.extensionId, cmdContext.api);
      const response = await getExtensions(cmdContext.api);

      cmdContext.updateState((draft) => {
        draft.extensions = [...response.extensions];
      });
    } finally {
      cmdContext.updateState((draft) => {
        draft.extensionsLoading = false;
      });
    }
  };
